module.exports = __webpack_public_path__ + "static/img/Boss_31087.772fef95.png";